module.exports = __webpack_public_path__ + "img/float-btn-sports.79dec648.svg";